import { createRouter, createWebHistory } from 'vue-router';
import Rest from "@/components/rest.vue"


const routes = [
  {path: '/', name: 'Rest', component: Rest},
];

// Create the router instance
const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
